

































































import Vue from 'vue'

import TitleName from '../atoms/TitleName.vue'
import SubjectTitle from '../atoms/SubjectTitle.vue'
import ModalPanel from '../atoms/ModalPanel.vue'
import ReturnButton from '../atoms/ReturnButton.vue'
import ContentHeaderSection from '../organisms/ContentHeaderSection.vue'
import ContentSectionPdf from '../organisms/ContentSectionPdf.vue'
import { icons } from '../../constants/icons'

export type DataType = {
  subjects: Array<{
    name: string
    subject_id: number
  }>
  pngs: Array<string>
  showContent: boolean
  completeFetchPng: boolean
  pageNumber: number
  backnumber: string
  icons?:any
}

export default Vue.extend({
  components: {
    TitleName,
    SubjectTitle,
    ReturnButton,
    ModalPanel,
    ContentHeaderSection,
    ContentSectionPdf
  },

  data(): DataType {
    return {
      showContent: false,
      completeFetchPng: false,
      pageNumber: 0,
      icons: icons,
      subjects: [
        {
          name: '国語',
          subject_id: 1
        },
        {
          name: '算数',
          subject_id: 2
        },
        {
          name: '思考の達人ツール',
          subject_id: 4
        },
        {
          name: '複合教科問題',
          subject_id: 3
        },
        {
          name: '表紙',
          subject_id: 6
        },
        {
          name: 'えい語',
          subject_id: 5
        }
      ],
      pngs: [],
      backnumber: 'バックナンバー'
    }
  },
  computed: {
    year() {
      return this.$store.state.year
    },
    month() {
      if (!this.$store.state.month) return ''
      return this.$store.state.month
    },
    grade() {
      return this.$store.state.grade
    },
    selectedContract() {
      if (!this.year || !this.month) return null
      const selectedMonth = this.year.toString() + ('0'+this.month).slice(-2)
      return this.$store.state.contracts.find((contract: any) => contract.month === selectedMonth)
    },
    selectedGrade() {
      const contract = (this as any).selectedContract
      return contract ? contract.grade : null
    },
    contracts() {
      return this.$store.state.contracts
    },
    texts() {
      return this.$store.state.texts
    },
    currentYear(){
      if (!this.$store.state.month) return ''
      return this.$store.state.month > 3 ? this.$store.state.year: this.$store.state.year - 1
    },
    returnUrl() {
      return `${process.env.VUE_APP_ROOT_PATH}/participant/my-page`
    },
    untilMonth() {
      if (!this.month) return ''

      // grade6 month6~3
      if (this.selectedContract != null && this.selectedContract.course === 'S6') {
        if (this.month >= 6) {
          return ((this as any).year + 1) + '年' + 4
        } else if (this.month <= 3) {
          return ((this as any).year) + '年' + 4
        }
      }

      if (this.month > 1){
        return ((this as any).year + 1) + '年' + ((this as any).month -1)
      } else {
        return ((this as any).year) + '年' + 12
      }
    },
    yearDate(){
      const today = new Date(this.$store.state.currentDate)
      return today.getMonth() + 1 > 3 ? today.getFullYear(): today.getFullYear() - 1
    },
  },
  async created() {
    const memberId = this.$cookies.get('member_id')
    const initialFlag = this.$cookies.get('initial_flag') === 'true'

    if (initialFlag) {
      this.$store.commit('SET_TEXTS', {})
      this.$store.commit('SET_GRADE', {grade: null})
    }
    this.$store.commit('SET_MEMBERID', { memberId: memberId })
    this.$store.dispatch('getCurrentDate')
    if (!initialFlag) return
    this.$cookies.set('initial_flag', false)

    await this.$store.dispatch('getTexts')

    const today = new Date(this.$store.state.currentDate)

    const yearMonthValues = Object.entries(this.texts)
      .filter(([t, data]) => {
        if (!(data as any).release_time) return false
        const release = new Date((data as any).release_time)
        return release.getTime() <= today.getTime()
      })
      .map(([t, ]) => (t))

    const initialDisplayIssue = yearMonthValues.sort((a, b) => Number(b) - Number(a))[0]
    if (initialDisplayIssue) {
      this.$store.commit('SET_MONTH', { month: parseInt(initialDisplayIssue.slice(4)) })
      this.$store.commit('SET_YEAR', { year: parseInt(initialDisplayIssue.slice(0, 4)) })
    } else {
      this.$store.commit('SET_MONTH', { month: null })
      this.$store.commit('SET_YEAR', { year: null })
    }
  },
  methods: {
    openModal(page_number: number): void {
      this.completeFetchPng = false
      this.pageNumber = page_number
      this.showContent = true
    },
    closeModal(): void {
      if (this.completeFetchPng == false ) return

      this.pngs = []
      this.showContent = false
    }
  },
})
